import { FC } from 'react';
import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import Link from 'next/link';
import { InfoTable } from '../DetailModal/InfoTable';

import { SectionButton } from './styled';

const ToHistoryButton: FC<{ symbol }> = ({ symbol }) => (
  <Link href={`/securities/history?symbol=${symbol}&period=all`}>
    <SectionButton
      data-cy="transaction-history-button"
      className="button-unstyled full-button"
      type="button"
    >
      <InfoTable
        dataSource={[
          {
            label: <Text family="bold">Riwayat Transaksi</Text>,
            value: (
              <Flex align="center" style={{ gap: 4 }}>
                <Text family="bold" color={color.primary}>
                  See All
                </Text>
                <Iconmoon className="icon-trading_back reverse" />
              </Flex>
            ),
          },
        ]}
      />
    </SectionButton>
  </Link>
);

export default ToHistoryButton;
